<div
  class="top-part"
  [class.slim-design]="slimDesign()">
  <div
    class="selection-part"
    [class.disabled]="disabled()">
    @for (name of tabNames(); track name) {
      <button
        class="no-style selection-item"
        [ngClass]="{ 'tab-selected': selectedTab === name, 'show-border': showBorder() }"
        (click)="changeSelection(name)">
        <p>{{ name | translate }}</p>
      </button>
    }
  </div>
</div>
